import {createFileRoute} from '@tanstack/react-router';

import EventList from '@/patient/views/event/EventsList';

export const Route = createFileRoute('/(patient)/events')({
  component: EventList
});
